import React from "react";

const Impressum = () => {
  return (
    <div className="page-content">
      <h1>Impressum</h1>
      Angaben gemäß § 5 TMG
      <p>Loewe-Saal GmbH</p>
      <p>Handelsregister: Amtsgericht</p>
      <p>Charlottenburg HRB 144332 B</p>
      <p>Umsatsteuer-ID: DE285762440</p>
      <h2>Geschäftsführer:</h2>
      <p>Baris Akdag</p>
      <p>Adresse: Wiebestraße 42-45 10553 Berlin</p>
      <p>Kontakt: Mail: info@loewesaal.de</p>
      <p>Tel.: +49 30 34509587</p>
      <h2>EU-Streitschlichtung Die</h2>
      <p>
        Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung
        (OS) bereit: https://ec.europa.eu/consumers/odr/. Unsere E-Mail-Adresse
        finden Sie oben im Impressum.
        Verbraucher­streit­beilegung/Universal­schlichtungs­stelle Wir sind
        nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </p>
    </div>
  );
};

export default Impressum;
